import api from '@api/getBook'

export default {
  namespaced: true,
  state: {
    currentManageContent: 'MyBooks',
    currentSidebarIndex: 0,
    currentSidebarSubIndex: 0,
    bookListPages: -1,
    alreadyUse: 0,
    allSpace: 0,
    componentManager: 'Published', // 管理组件状态
    currentSubAccountSidebarIndex: 0, // 子账号当前父级目录
    currentSubAccountManageContent: '', // 子账号当前组件
    booksCurrentSubAccount: '' //显示作品列表的子账号
  },
  mutations: {
    UPDATE_CURRENT_MANAGE(state, name) {
      state.currentManageContent = name
    },
    UPDATE_SIDEBAR_SUBINDEX(state, index) {
      state.currentSidebarSubIndex = index
    },
    UPDATE_SIDEBAR_INFO(state, info) {
      state.currentSidebarSubIndex = info.subIndex
      state.currentSidebarIndex = info.index
      state.currentManageContent = info.component
    },
    UPDATE_SUB_ACCOUNT_SIDEBAR_INFO(state, info) {
      state.currentSubAccountSidebarIndex = info.index
      state.currentSubAccountManageContent = info.component
    },
    UPDATE_BOOK_LIST_PAGES(state, count) {
      state.bookListPages = count
    },
    UPDATE_BOOK_USE(state, alreadyUse) {
      state.alreadyUse = alreadyUse
    },
    UPDATE_BOOK_ALLSPACE(state, allSpace) {
      state.allSpace = allSpace
    },
    //更新专辑组件状态
    UPDATE_COMPONENTMANAGER(state, componentManager) {
      state.componentManager = componentManager
    },
    UPDATE_BOOKS_CURRENT_ACCOUNT(state, account) {
      state.booksCurrentSubAccount = account
    }
  }
}
